import React from 'react';
import styled from 'styled-components';

import {colorTheme} from '../../mixin/colorTheme';
import {Btn} from '../button/btn-type/Btn';
import {Icon} from '../Icon/Icon';
import {badgeColor, badgeRemovableCondition} from './badgeCondition';

const BadgeContainer = styled.span`
    padding: 1px var(--space-sm) 0;
    vertical-align: middle;
    display: inline-block;
    position: relative;
    font-weight: 400;
    margin-right: var(--space-xsm);
    margin-bottom: var(--space-xsm);
    color: var(--white-00);
    background-color: var(--disabled);
    border: 1px solid var(--disabled);
    border-radius: 4px;

    ${Icon.Wrapper} svg {
        padding-bottom: 2px;
    }
    ${({color, ghost, text, outline}) => badgeColor(color, ghost, text, outline)};
    ${({remove}) => badgeRemovableCondition(remove)};
    ${colorTheme({
        '--btn-default     ': {dark: 'var(--white-00)  ', light: 'var(--gray-13)'},
    })};

    ${({color, outline, ghost, text, link}) => {
        if (outline) {
            if (color === 'default') {
                return `
                color: var(--btn-default) !important;
                border: 1px solid var(--btn-default) !important;
                --default: var(--btn-default);
                `;
            } else return ``;
        }
        if (ghost) {
            if (color === 'default') {
                return `
                color: var(--btn-default) !important;
                border: 1px solid var(--btn-default) !important;
                --default: var(--btn-default);
                `;
            } else return ``;
        }
        if (text) {
            if (color === 'default') {
                return `
                color: var(--btn-default) !important;
                border: 1px solid var(--btn-default) !important;
                --default: var(--btn-default);
                `;
            } else return ``;
        }
        if (link) {
            if (color === 'default') {
                return `
                    color: var(--btn-default) !important;
                    --default: var(--btn-default);
                `;
            } else return ``;
        } else {
            if (color === 'default')
                return `
                color: var(--default-btn-text-color)!important;
                --default: var(--btn-default);
            `;
            else return ``;
        }
    }}
`;

/**
 * @param {object} param0
 * @param {React.ReactNode} param0.children
 * @param {import('react').MouseEventHandler} [param0.remove]
 * @param {boolean} [param0.outline]
 * @param {boolean} [param0.text]
 * @param {boolean} [param0.ghost]
 * @param {string} [param0.color]
 * @param {string} [param0.title]
 */
const Badge = ({children, remove, outline, text, ghost, color, title}) => (
    <BadgeContainer title={title} outline={outline} ghost={ghost} text={text} color={color} remove={remove}>
        {children}
        {remove && (
            <Btn round color="danger" onClick={remove} type="button">
                <Icon type="sm" name="Close" />
            </Btn>
        )}
    </BadgeContainer>
);

Badge.Container = BadgeContainer;
export {Badge, BadgeContainer};
